import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NightsStayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nights_stay"}/>
}
